<template>
    <section>
        <header class="f fh fa-c b-b sp-m">
            <div class="te-fat-light">{{ 'mead.filters' | athT }}</div>
            <div class="fg"></div>
            <ButtonIcon icon="cross" class="el--s-s" @click="onClose" />
        </header>
        <div class="f fh fa-c ov">
            <DashboardItemConfigExpanded :config="childPropsInternal"
                :sections="configurationSections"
                :dashboardType="dashboardType"
                :dashboard="dashboard"
                :widgetType="childType"
                @onConfigUpdated="onConfigUpdated" />
        </div>
    </section>
</template>
<script>
import DashboardItemConfigExpanded from '../configuration/DashboardItemConfigExpanded.vue';
import ButtonIcon from '../../../atoms/ButtonIcon.vue';

/**
 * This widget can be used to create a popover for a dashboard widget based on its configuration
 * settings.
 *
 * Usage:
 *
 * Create a popover with this widget with the popover service like the following.
 *
 *   const config = new PopoverConfig()
 *      .setComponent(DashboardConfigPopover) // This widget
 *      .setEvent(event) // Event, not sure if needed
 *      .setProps({
 *          // Child props should be all the props the dashboard widget expects to function
 *          childProps: Object.assign({}, this.internal_config),
 *          // The type of widget that opened the popover
 *          childType: tKeys.WIDGET_STORE.PI_KPI_BAR_CHART,
 *          dashboardType: this.dashboardType,
 *          // Required to get the updated config
 *          pubkey: this.uid,
 *      })
 *   PopoverService.open(config);
 *
 * In the consumer widget you need to listen to the update event.
 *
 * Flash.subscribe(this.uid, `${this.uid}:widget_config_update`, this.onMetricsUpdated);
 */
export default {
    props: {
        /**
         * Unique key identifying the consuming widget, used to publish the
         * `${pubkey}:widget_config_update` Flash event so the widget can pick up
         * configuration changes made in this popover.
         */
        pubkey: {type: String, default: ''},
        /**
         * The current props / configuration for the widget that opened this
         * popover. Used to seed the internal config passed down to the
         * configuration widgets and emitted back on update.
         */
        childProps: {type: Object, default: () => ({})},
        /**
         * The type of the widget we are configuring, used to look up its
         * configuration sections via DashboardService.
         */
        childType: {type: String, default: ''},
        /**
         * The type of dashboard the widget belongs to.
         */
        dashboardType: {type: String, default: ''},
        /**
         * The entire Dashboard object the widget belongs to.
         */
        dashboard: {type: Object, default: () => ({})},
    },
    components: {DashboardItemConfigExpanded, ButtonIcon},
    data () {
        return {
            childPropsInternal: this.childProps,
        };
    },
    methods: {
        /**
         * Configuration updated from child configuration widgets
         * @param options
         */
        onConfigUpdated: function (options) {
            // Some value types were not getting proper updates with watchers
            // in dashboard widgets. Stringify and parse made those updates work.
            this.childPropsInternal = JSON.parse(JSON.stringify(options));
            MeadCommon.Flash.publish(`${this.pubkey}:widget_config_update`, this.childPropsInternal);
        },
        onClose: function() {
            MeadCommon.PopoverService.close();
        }
    },
    computed: {
        /**
         * Returns the configuration sections for the selected child widget
         */
        configurationSections: function () {
            return MeadCommon.DashboardService.hasWidgetDefinition(this.childType) ?
                MeadCommon.DashboardService.getWidgetDefinition(this.childType).getConfigurationSections() : []
        },
    }
};
</script>
